'use client';

import CookieService from '@/components/default/services/app/cookie.service';
import DashboardService from '@/components/default/services/api/dashboard/dashboard.service';
import { useSelector } from 'react-redux';
import { RootState } from '@/components/default/redux/store';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Loading from '@/components/layouts/loading';

const CheckAuthProvider = ({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const [isAuthChecking, setIsAuthChecking] = useState(true);

    const { domainType, mainDomain, subDomain, customDomain } = useSelector((state: RootState) => state.domain);

    useEffect(() => {
        if (domainType) {
            const auth_token = CookieService.get('token');
            if (auth_token) {
                // console.log('auth_token', auth_token);
                let domain = '';
                if (domainType === 'main') {
                    domain = mainDomain || '';
                } else if (domainType == 'sub') {
                    domain = subDomain || '';
                } else if (domainType == 'custom') {
                    domain = customDomain || '';
                }
                // ✅ Do your login validation here...
                DashboardService.checkLoggedInUser(auth_token, domainType, domain)
                    .then((response) => {
                        router.push('/t/home'); // Redirect to home
                    })
                    .catch((error) => {
                        console.error('Dashboard error:', error);
                        setIsAuthChecking(false);
                    });
            } else {
                // console.log('auth token null');
                setIsAuthChecking(false);
            }
        }
    }, [router, customDomain, dispatch, mainDomain, domainType, subDomain]);

    if (isAuthChecking) return <Loading />; // Don't render anything if page is not loading

    // If page is loading, render the children components
    return <>{children}</>;
};

export default CheckAuthProvider;
